import { render } from "./MainCube.vue?vue&type=template&id=ac21eae8&scoped=true&ts=true"
import script from "./MainCube.vue?vue&type=script&lang=ts"
export * from "./MainCube.vue?vue&type=script&lang=ts"

import "./MainCube.vue?vue&type=style&index=0&id=ac21eae8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac21eae8"]])

export default __exports__